import React, { useState } from 'react';

const TokenDisplayModal = ({ token, tokenData, onClose }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(token);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const downloadToken = () => {
    const blob = new Blob([token], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `api-token-${tokenData.token_prefix}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-lg p-8 max-w-3xl w-full mx-4" onClick={(e) => e.stopPropagation()}>
        {/* Warning Banner */}
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6">
          <div className="flex items-center">
            <svg className="h-6 w-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <span className="font-bold text-lg">IMPORTANT: This token will only be shown ONCE!</span>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-800 mb-4">API Token Generated Successfully</h2>

        {/* Token Display */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Your API Token:
          </label>
          <div className="bg-gray-100 border border-gray-300 rounded p-3 font-mono text-sm break-all select-all">
            {token}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mb-6">
          <button
            onClick={copyToClipboard}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition duration-200"
          >
            {copied ? '✓ Copied!' : '📋 Copy to Clipboard'}
          </button>
          <button
            onClick={downloadToken}
            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded transition duration-200"
          >
            💾 Download as File
          </button>
        </div>

        {/* Usage Example */}
        <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-6">
          <h3 className="font-semibold text-gray-700 mb-2">Usage Example:</h3>
          <pre className="bg-gray-800 text-green-400 p-3 rounded text-xs overflow-x-auto">
            <code>{`curl -H "Authorization: Bearer ${token}" \\
  ${window.location.origin}/api/customers`}</code>
          </pre>
        </div>

        {/* Warning Footer */}
        <div className="bg-red-50 border border-red-200 rounded p-4 mb-6">
          <p className="text-red-800 font-medium mb-2">
            ⚠️ Save this token securely. You will not be able to see it again.
          </p>
          <p className="text-red-700 text-sm">
            If you lose this token, you will need to generate a new one.
          </p>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded transition duration-200"
        >
          I've Saved My Token - Close
        </button>
      </div>
    </div>
  );
};

export default TokenDisplayModal;
